import { CountryEnum, CurrencyEnum } from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const validationMessagesResource = Resources.base.market.validationMessages;

export const getGeneralFormSchema = (
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
) => {
	return z.object({
		name: z
			.string()
			.nonempty({ message: `${t(validationMessagesResource.name)}` }),
		country: z.nativeEnum(CountryEnum),
		currency: z.nativeEnum(CurrencyEnum),
		webReferrer: z
			.string()
			.nonempty({ message: `${t(validationMessagesResource.webReferrer)}` }),
		urlPath: z
			.string()
			.nonempty({ message: `${t(validationMessagesResource.urlPath)}` }),
		companyId: z.number().int(),
		companyBankDetailId: z.number().int().optional(),
		timezone: z.string().nullable().optional(),
	});
};

export type GeneralFormSchema = z.infer<
	ReturnType<typeof getGeneralFormSchema>
>;
